import { useLocalSearchParams } from 'expo-router';

import IncomeSplitSettings from '../../../banking/components/income-split/IncomeSplitSettings';
import IncomeSplitSettingsNew from '../../../banking/components/income-split/IncomeSplitSettingsNew';
import useShouldSeeTiedRules from '../../../banking/hooks/income-split/useShouldSeeRuleSets';

export default function IncomeSettingsScreen() {
    const { tiedRules } = useLocalSearchParams<{
        tiedRules: string;
    }>();

    const enableTiedRules = useShouldSeeTiedRules();

    if (tiedRules === 'true' && enableTiedRules) {
        return <IncomeSplitSettingsNew />;
    }

    return <IncomeSplitSettings />;
}
